module.exports = __webpack_public_path__ + "static/media/Abacus.c77ff84b.svg";